import { getCanvasHeight, getCanvasWidth, PageFormat } from '@ritabygglov/core';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { useUser } from '../../context/User/useUser';
import { useImageDimensions } from '../../hooks/useImageDimensions';
import { useRoomId } from '../../hooks/useRoomId';

const isImageSizeInvalid = (
  width: number,
  height: number,
  canvasWidth: number,
  canvasHeight: number
) => {
  if (width <= 0.9 * canvasWidth) {
    return true;
  }
  if (height <= 0.9 * canvasHeight) {
    return true;
  }
  return false;
};

export function RenderMap() {
  const user = useUser();
  const canvasId = useRoomId();
  const canvas = user.canvases.find((c) => c.canvasId === canvasId);
  const intl = useIntl();
  const { width, height } = useImageDimensions(
    canvas?.mapUrl || '',
    canvas?.pageFormat || PageFormat.A3_LANDSCAPE
  );

  const canvasWidth = getCanvasWidth(canvas?.pageFormat);
  const canvasHeight = getCanvasHeight(canvas?.pageFormat);

  const location = useLocation();
  const isExport = location.pathname.includes('export');

  if (!canvas) return null;

  const showImageWarning =
    canvas?.mapUrl &&
    isImageSizeInvalid(width, height, canvasWidth, canvasHeight);

  return (
    <g id="render-container">
      <rect
        id="render-map-canvas"
        fill="white"
        stroke={isExport ? 'none' : 'var(--border)'}
        width={canvasWidth}
        height={canvasHeight}
      ></rect>
      {canvas?.mapUrl && (
        <image
          id="map"
          xlinkHref={canvas.mapUrl}
          width={width}
          height={height}
        />
      )}

      {showImageWarning && (
        <text
          x={canvasWidth / 2}
          y={-20}
          textAnchor="middle"
          fontSize="18"
          fill="red"
        >
          {intl.formatMessage({ id: 'renderMap.formatWarning' })}
        </text>
      )}
    </g>
  );
}
